import { render, staticRenderFns } from "./view3dPage.vue?vue&type=template&id=f9586ed8&scoped=true&"
import script from "./view3dPage.vue?vue&type=script&lang=js&"
export * from "./view3dPage.vue?vue&type=script&lang=js&"
import style0 from "./view3dPage.vue?vue&type=style&index=0&id=f9586ed8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9586ed8",
  null
  
)

export default component.exports